import { CenterTypeDatasource } from "@beneficiary/data/datasource/center-type.datasource";
import { BeneficiaryCenterTypesError } from "@beneficiary/domain/errors/beneficiary.error";
import { CenterTypesMapperError } from "@beneficiary/domain/errors/center-types/center-types-mapper.error";
import { CenterType } from "@beneficiary/domain/models/center-type.model";
import { Either } from "@core/domain/types/either";
import { inject, injectable } from "inversify";

@injectable()
export class CenterTypesRepository {
    constructor(
        @inject(CenterTypeDatasource)
        private readonly centerTypeDatasource: CenterTypeDatasource,
    ) { }

    async getAll(): Promise<Either<BeneficiaryCenterTypesError | CenterTypesMapperError, CenterType[]>> {
        const centerTypeResult = await this.centerTypeDatasource.fetchAll();

        return centerTypeResult.map((centerType) => centerType);
    }
}
